import React from 'react';
import MainTitle from '../../components/page/main-title/MainTitle';
import './page.css';
import Beto from '../../img/betoIntro.png';
import Button from '../../components/buttons/Button';
import STRINGS from './../../data/language/language';

export default class Page extends React.Component{
  constructor(props){
    super(props);

    this.state = {
      strings: STRINGS[window.LANGUAGE]
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.opentecnicas = this.opentecnicas.bind(this);
  }

  componentDidMount(){
    window.scrollTo(0, 0);
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.history.push('/area-restrita/meu-treino/');
  }

  opentecnicas(e) {
    e.preventDefault();
    this.props.history.push('/area-restrita/tecnicas/');
  }

  render(){
    const strings = this.state.strings;
    return(
      <div className="page-dashboard page-content" >
        <div className="container">
          <div className="container-box">
            <div className="container-box--inner">
              <MainTitle title="Seja bem-vindo(a)"></MainTitle>
              <div>
                <div className='img-beto'><img src={Beto} /></div>
                <div>
                <br />
                <br />
                  <div>{strings.intro1}</div><br /><br />
                  <div>{strings.intro2}</div><br /><br />
                  <div>{strings.intro3}</div><br /><br />
                  <div>{strings.intro9}</div><br /><br />
                  <Button
                    text="CLIQUE AQUI ANTES DE COMEÇAR A TREINAR"
                    type='button'
                    classes="button-login simple-button"
                    onClick={this.opentecnicas}
                  />
                  <br />
                  <br />
                  <br />
                  <div className='title-sobre-treinos'>SOBRE AS PLANILHAS DE TREINO:</div><br /><br />
                  <div>{strings.intro5}</div><br />
                  <div>{strings.intro6}</div><br />
                    <Button
                      text="CLIQUE AQUI ANTES DE COMEÇAR A TREINAR"
                      type='button'
                      classes="button-login simple-button"
                      onClick={this.opentecnicas}
                    />
                  <br />
                  <br />
                  <div>{strings.intro7}</div><br />
                  <div>{strings.intro8}</div><br /><br />
                  <Button
                    text="Acessar meu treino"
                    type='button'
                    classes="button-login simple-button"
                    onClick={this.handleSubmit}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/welcome/Page.js